module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("关于木材码头app介绍")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "content"
  }, [_vm._v("       木材码头（www.mulian****.com）是杭州龙桥电子商务有限公司旗下的大型木业全产业链交易平台，是木业行业第一家真正实现木业上下游产业链资源精准匹配的交易平台。\n       木材码头依托中国木业网、众品家具网、木门品牌招商网及众品地板网四大门户网站在木业行业服务十多年的经验及上下游产业链资源，深入到木业整个产业链的买卖流通环节，真正实现用互联网电子商务改变木业行业传统贸易模式，帮助木业产业链企业在面临互联网巨浪冲击下实现产业快速转型。\n       木材码头的定位是打造木业行业最大最专业的木业产业链交易平台，引领木业行业的产业电商化，利用在木业行业服务10多年的行业资源和用户口碑，快速撮合买卖双方的交易，本着“免费快速搜货，低价安全买货”的服务宗旨，充分发挥互联网大数据在木业产业链交易中的作用，实现帮买家快速找到性价比最高的货源，帮卖家快速销售库存现货，降低买卖双方在交易环节的时间、人力、资金等各种成本；并结合整个行业大数据的监测和分析，为木业产业链的良性健康发展提供指导方向。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-646b306e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/help/HomeHelpContent.vue
// module id = 153
// module chunks = 1